import { render } from "./TemplateManagement.vue?vue&type=template&id=2385d990"
import script from "./TemplateManagement.vue?vue&type=script&lang=js"
export * from "./TemplateManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__